export const transferTypes = ["acte authentique", "acte sous seing privé"] as const
type TransferType = typeof transferTypes[number]

export const taxServices = ["Service des impôts des entreprises (SIE)", "Service départemental des Enregistrements (SDE)"] as const
type TaxServiceType = typeof taxServices[number]

export const registrationNumbers = ["", "N° de bordereau et N° d'extrait", "N° du dossier"] as const
type RegistrationNumberType = typeof registrationNumbers[number]

export const entityTypes = ["Personne physique", "Personne morale"] as const
type EntityType = typeof entityTypes[number]

export const individualObjectKeys = ["civility", "firstName", "lastName", "postalCode", "city", "address", "additionalAddress", "registrationOffice", "cities"] as const
export type individualObjectKeyType = typeof individualObjectKeys[number]

export const civilities = ["Monsieur", "Madame"] as const
export type civilityType = typeof civilities[number]

// acte de cession de fonds
export type BusinessTransferDeed = {
    transferType: TransferType,
    transferDate: string,
    signingLocation?: string
}

// enregistrement du service des impôts
export type TaxOfficeRegistration = {
    service: TaxServiceType,
    city: string
}

// mention d'enregistrement
export type RegistrationDetails =
    | {
        registrationNumberType: "";
        date: string;
    } | {
        registrationNumberType: "N° du dossier";
        date: string;
        fileNumber: string;
        referenceNumber?: string;
    } | {
        registrationNumberType: "N° de bordereau et N° d'extrait";
        date: string;
        borderNumber: string;
        boxNumber: string;
        extractNumber?: string;
    }

// adresse du fonds
export type busnessAddress = {
    address: string,
    additionalAddress: string,
    postalCode: string,
    city: string,
    cities?: string[]
}

// lieu d'opposition
type oppositionLocation = {
    address: string;
    additionalAddress?: string;
    postalCode: string;
    city: string;
    cities?: string[]
}

// Type pour les options de lieu
type locationType = 'Adresse identique au fonds cédé' | 'Autre adresse';

// Type principal pour l'opposition avec une union discriminée
export type oppositionLocationAddress = {
    location: locationType;
} & (
        | {
            location: 'Adresse identique au fonds cédé';
            validity: oppositionLocation;
        }
        | {
            location: 'Autre adresse';
            accordance: oppositionLocation;
            validity: oppositionLocation;
        }
    )